// 智能诊股 未购买
<template>
  <div class="notBuy">
    <!-- <img
      class="bg"
      :src="require('@/assets/images/znzg/bg.png')"
      alt=""
      srcset=""
    /> -->

    <div class="infoBox">
      <dl>
        <dt>贵州茅台(sh600519)</dt>
        <dd>
          <span>2009.85</span>
          <span>+1.95%</span>
        </dd>
      </dl>
      <ul>
        <li v-for="(item, i) in infos.li3" :key="i">
          <div class="ico">
            <img
              :class="'img' + (i + 1)"
              :src="require('@/assets/images/znzg/' + (i + 1) + '.png')"
            />
          </div>
          <p>{{ item.str[0] }}</p>
          <p>{{ item.str[1] }}</p>
        </li>
      </ul>
      <a href="javascript:;" class="btn">查看此诊股 只需30金币</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infos: {
        li3: [
          {
            str: ["大数据诊断", "精准解析个股状态"],
          },
          {
            str: ["人工智能技术", "多因子深度诊断"],
          },
          {
            str: ["智能评分系统", "AI系统独有持仓建议"],
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scope>
@import "~@/assets/sass/global.scss";
.notBuy {
  height: 100vh;
  background: url(../../assets/images/znzg/bg.png) 0 rem(-90px);
  background-size: cover;
  .bg {
    width: 100%;
    display: block;
  }
  .infoBox {
    position: fixed;
    bottom: rem(92px);
    left: rem(-336px);
    margin-left: 50%;
    width: rem(673px);
    height: rem(455px);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
    border-radius: rem(20px);
    dl {
      text-align: center;
      padding: rem(28px) 0;
      dt {
        font-size: rem(30px);
        font-weight: 400;
        color: #000000;
        line-height: rem(42px);
      }
      dd {
        color: #fe484a;
        line-height: rem(42px);
        span {
          padding: rem(15px);
        }
      }
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: rem(40px) auto 0;
      width: rem(475px);
      height: rem(92px);
      background: #fe484a;
      box-shadow: 0px rem(4px) rem(11px) 0px rgba(231, 69, 69, 0.5);
      border-radius: rem(53px);
      font-size: rem(30px);
      font-weight: 400;
      color: #ffffff;
      line-height: rem(42px);
    }
    ul {
      display: flex;
      justify-content: space-evenly;
      li {
        text-align: center;
        .ico {
          display: flex;
          justify-content: center;
          align-items: center;
          height: rem(100px);
          img {
            height: auto;
            &.img1 {
              width: rem(55px);
            }
            &.img2 {
              width: rem(55px);
            }
            &.img3 {
              width: rem(50px);
            }
          }
        }
        p {
          font-size: rem(20px);
          font-weight: 400;
          color: #333333;
          line-height: rem(28px);
        }
      }
    }
  }
}
</style>
